import type { Step } from "react-joyride";

export const leaveTypeEditTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າແກ້ໄຂປະເພດລາ. ແກ້ໄຂຂໍ້ມູນ ແລ້ວບັນທຶກ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-type-edit-back"]',
    content: "ກັບຄືນສູ່ລາຍລະອຽດປະເພດລາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-type-edit-form"]',
    content: "ຟອມແກ້ໄຂປະເພດລາ. ບັນທຶກການແກ້ໄຂ.",
    placement: "top",
  },
];
